module.exports = __webpack_public_path__ + "img/bg_address.c64f6858.png";